// extracted by mini-css-extract-plugin
export var inline = "_we-0";